import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { AuthCallback } from '../auth/AuthCallback';
import { AuthGate } from '../auth/AuthGate';
import { HomeRedirect, RequireMode } from './guards';
import { SessionProvider } from './session';
import { Shell } from './Shell';
import { Toasts } from './Toasts';
import { CasesPage } from '../pages/doctor/CasesPage';
import { PatientsPage } from '../pages/doctor/PatientsPage';
import { BoardPage } from '../pages/lab/BoardPage';
import { PartnersPage } from '../pages/lab/PartnersPage';
import { UsersPage } from '../pages/admin/UsersPage';
import { OrgsPage } from '../pages/admin/OrgsPage';
import { AuditPage } from '../pages/admin/AuditPage';
import { NoAccessPage } from '../pages/NoAccessPage';

// Страницы с 3D-просмотром грузятся отдельным чанком вместе с three.js.
const CasePage = lazy(() => import('../pages/doctor/CasePage'));
const NewCasePage = lazy(() => import('../pages/doctor/new-case/NewCasePage'));
const WorkPage = lazy(() => import('../pages/lab/WorkPage'));

function Loading() {
  const { t } = useTranslation();
  return <div className="loading">{t('common.loading')}</div>;
}

function AppRoutes() {
  return (
    <SessionProvider>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<Shell />}>
            <Route index element={<HomeRedirect />} />
            <Route
              path="cases"
              element={
                <RequireMode mode="doctor">
                  <CasesPage />
                </RequireMode>
              }
            />
            <Route
              path="cases/:id"
              element={
                <RequireMode mode="doctor">
                  <CasePage />
                </RequireMode>
              }
            />
            <Route
              path="patients"
              element={
                <RequireMode mode="doctor">
                  <PatientsPage />
                </RequireMode>
              }
            />
            <Route
              path="new"
              element={
                <RequireMode mode="doctor">
                  <NewCasePage />
                </RequireMode>
              }
            />
            <Route
              path="board"
              element={
                <RequireMode mode="lab">
                  <BoardPage />
                </RequireMode>
              }
            />
            <Route
              path="work/:id"
              element={
                <RequireMode mode="lab">
                  <WorkPage />
                </RequireMode>
              }
            />
            <Route
              path="partners"
              element={
                <RequireMode mode="lab">
                  <PartnersPage />
                </RequireMode>
              }
            />
            <Route
              path="admin/users"
              element={
                <RequireMode mode="admin">
                  <UsersPage />
                </RequireMode>
              }
            />
            <Route
              path="admin/orgs"
              element={
                <RequireMode mode="admin">
                  <OrgsPage />
                </RequireMode>
              }
            />
            <Route
              path="admin/audit"
              element={
                <RequireMode mode="admin">
                  <AuditPage />
                </RequireMode>
              }
            />
            <Route
              path="no-access"
              element={
                <RequireMode mode="none">
                  <NoAccessPage />
                </RequireMode>
              }
            />
            <Route path="*" element={<HomeRedirect />} />
          </Route>
        </Routes>
      </Suspense>
    </SessionProvider>
  );
}

export function App() {
  return (
    <>
      <Routes>
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route
          path="*"
          element={
            <AuthGate>
              <AppRoutes />
            </AuthGate>
          }
        />
      </Routes>
      <Toasts />
    </>
  );
}
